import {
   HealthcareProviderAppointmentConfirmationPractitionerNotificationConfigurationQuery,
   HealthcareProviderNotificationConfiguration,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';

type PractitionerPhoneNotificationAppointmentConfirmationToggleLoaderRenderProps = {
   notificationEnabled: boolean;
   messages: string[];
   refetch: VoidFunction;
};

type PractitionerPhoneNotificationAppointmentConfirmationToggleLoaderProps = {
   readonly children: (
      result: PractitionerPhoneNotificationAppointmentConfirmationToggleLoaderRenderProps
   ) => JSX.Element;
};

export const PractitionerPhoneNotificationAppointmentConfirmationToggleLoader = (
   props: PractitionerPhoneNotificationAppointmentConfirmationToggleLoaderProps
): JSX.Element | null => {
   const {
      data: healthcareProviderNotificationConfiguration,
      loading: healthcareProviderNotificationConfigurationLoading,
      error: healthcareProviderNotificationConfigurationError,
      refetch,
   } = useCqrsGet<HealthcareProviderNotificationConfiguration>(() => {
      return new HealthcareProviderAppointmentConfirmationPractitionerNotificationConfigurationQuery();
   });

   if (
      healthcareProviderNotificationConfigurationLoading ||
      healthcareProviderNotificationConfigurationError ||
      !healthcareProviderNotificationConfiguration
   ) {
      return null;
   }

   return props.children({
      notificationEnabled: healthcareProviderNotificationConfiguration.enabled,
      messages: healthcareProviderNotificationConfiguration.messages,
      refetch: refetch,
   });
};
